module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_0.06ae4cd7.png";